
import React from "react";
import BusinessCard from "@/components/BusinessCard";
import { Business } from "@/types";

interface BusinessGridProps {
  businesses: Business[];
}

const BusinessGrid: React.FC<BusinessGridProps> = ({ businesses }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {businesses.map((business) => (
        <BusinessCard key={business.id} business={business} />
      ))}
    </div>
  );
};

export default BusinessGrid;
